import { clsx } from 'clsx'

import { Avatar, AvatarRounded } from '@tribeplatform/react-ui-kit/Avatar'

import { BC } from '../../types/index.js'
import { ImageBlockProps } from './types.js'

export type ImageRounded = 'circle' | 'squared' | 'rounded'

const sizesMap: Record<ImageRounded, AvatarRounded> = {
  circle: 'avatar',
  squared: 'none',
  rounded: 'base',
}
export const roundedMapper = (size: ImageBlockProps['shape']) => sizesMap[size]

export const ImageBlock: BC<ImageBlockProps> = ({
  url,
  size = 'md',
  shape = 'circle',
  className,
  ...rest
}) => {
  if (!url) {
    return null
  }

  return (
    <Avatar
      size={size}
      rounded={roundedMapper(shape)}
      src={url}
      className={clsx('flex', className)}
      {...rest}
    />
  )
}
